import { CheckCircle, XCircle } from 'lucide-react';
import React from 'react';
import { cn } from '../ui/utils';

const FIBBlankReview = ({ isCorrect, value, answers }) => {
  return (
    <span className="mx-px inline-flex align-middle flex-wrap items-center gap-1">
      <span
        className={cn(
          'inline-flex items-center gap-1 rounded-md border px-2 py-1 text-sm',
          isCorrect
            ? 'border-green-200 bg-green-50 text-green-800'
            : 'border-red-200 bg-red-50 text-red-800 line-through'
        )}
      >
        {value?.[0] || '—'}
        {isCorrect ? (
          <CheckCircle className="h-3.5 w-3.5 text-green-600" />
        ) : (
          <XCircle className="h-3.5 w-3.5 text-red-500" />
        )}
      </span>
      {!isCorrect && answers?.[0] && (
        <span className="inline-flex items-center gap-1 rounded-md border border-green-200 bg-green-50 px-2 py-1 text-sm text-green-800">
          {answers[0]}
          <CheckCircle className="h-3.5 w-3.5 text-green-600" />
        </span>
      )}
    </span>
  );
};

export default FIBBlankReview;
